export enum AppName {
  APOLLO_READING = 'apolloreading',
  READING_CRITTERS = 'readingcritters',
}
